module.exports = __webpack_public_path__ + "img/laptop-phone.aa31a490.png";